import { useCommands, useEditorState } from '@remirror/react';
import CommandButton from '../CommandButton';
import React from 'react';

export const ClearFormattingButton = () => {
  const commands = useCommands();
  const state = useEditorState();

  const onClickHandler = () => {
    if (!state || !state.selection) return;
    const marks = Object.values(state.schema.marks);
    const selection = state.selection;
    for (let mark of marks) {
      if (mark.name !== 'inlineComment') {
        commands.removeMark({ selection, type: mark });
      }
    }
    commands.focus();
  };

  return (
    <CommandButton
      label={'Clear'}
      labelOptions={{ className: 'command__button-text weight-normal' }}
      enabled={true}
      onClick={onClickHandler}
    />
  );
};
